var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-container',[_c('v-row',{staticClass:"px-5"},[_c('v-toolbar',{attrs:{"flat":""}},[_c('v-text-field',{attrs:{"hide-details":"","prepend-icon":"fa-search","single-line":""}})],1)],1)],1),_c('AppTiles')],1)}
var staticRenderFns = []

export { render, staticRenderFns }